import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  options: string[];
  title: string;
  line1: string;
  buttonText: string;
}

@Component({
    selector: 'fc-dialog-select-option',
    templateUrl: './dialog-select-option.component.html',
    styleUrls: ['./dialog-select-option.component.scss'],
    standalone: false
})
export class DialogSelectOptionComponent {
  selectForm: UntypedFormGroup;
  options: string[];

  constructor(
    readonly formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<DialogSelectOptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.options = data.options;
    this.selectForm = this.formBuilder.group({
      field: [''],
    });
  }

  onYesClick(): void {
    const selectedLayer = this.selectForm.get('field').value;
    this.dialogRef.close(selectedLayer);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
